import { render, staticRenderFns } from "./ModalUsuarioAplicacao.vue?vue&type=template&id=4f3f6c2f&scoped=true"
import script from "./ModalUsuarioAplicacao.vue?vue&type=script&lang=js"
export * from "./ModalUsuarioAplicacao.vue?vue&type=script&lang=js"
import style0 from "./ModalUsuarioAplicacao.vue?vue&type=style&index=0&id=4f3f6c2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f6c2f",
  null
  
)

export default component.exports